import { Parm0Callback } from "@Components/app/members/teamInterfaces";
import PinSetupPanel from "@Components/app/settings/pin-setup-panel";
import { Dialog } from "@mui/material";

const PinSetupDialog = ({
  open = false,
  pinLength = 4,
  onSuccess = () => {},
}: {
  open: boolean;
  pinLength?: number;
  onSuccess?: Parm0Callback;
}) => (
  <Dialog open={open} fullScreen>
    <PinSetupPanel pinLength={pinLength} onSuccess={onSuccess} />
  </Dialog>
);

export default PinSetupDialog;
